import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpecificationsRoutingModule } from './specifications-routing.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SpecificationsRoutingModule
  ]
})
export class SpecificationsModule { }
